import { render, staticRenderFns } from "./ActiveRulesLimitReachedModal.vue?vue&type=template&id=5bc6e6ab&scoped=true&"
import script from "./ActiveRulesLimitReachedModal.vue?vue&type=script&lang=ts&"
export * from "./ActiveRulesLimitReachedModal.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveRulesLimitReachedModal.vue?vue&type=style&index=0&id=5bc6e6ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6e6ab",
  null
  
)

export default component.exports